import { inject, Injectable } from '@angular/core';
import { JwtDecoder } from './jwt-decoder';
import { JwtToken } from './models/jwt-token';
import { TokenStorageService } from './token-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly tokenStorageService = inject(TokenStorageService);

  hasAccessToken(): boolean {
    return !!this.tokenStorageService.getAccessToken();
  }

  isAccessTokenExpired(): boolean {
    const token = this.tokenStorageService.getAccessToken();

    if (!token) {
      return false;
    }

    return JwtDecoder.isTokenExpired(token);
  }

  getAccessToken(): JwtToken | null {
    const token = this.tokenStorageService.getAccessToken();

    if (!token) {
      return null;
    }

    return JwtDecoder.decodeToken(token);
  }

  clearAccessToken(): void {
    this.tokenStorageService.clear();
  }
}
